// import { Star, MapPin } from "lucide-react";
// import { Link } from "react-router-dom";


// const centres = [
//     { city: "Visakhapatnam", rating: 4.8, machines: 42, experts: 18 },
//     { city: "Vijayawada", rating: 4.7, machines: 36, experts: 14 },
//     { city: "Tirupati", rating: 4.6, machines: 29, experts: 12 },
//     { city: "Kurnool", rating: 4.5, machines: 24, experts: 9 },
// ];

// export default function ExploreCentres() {
//     return (
//         <section className="max-w-7xl mx-auto px-6 py-20" id="facilities">
//             <div className="flex items-end justify-between mb-10 flex-wrap gap-4">
//                 <div>

//                     <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-3">
//                         Explore APIC Centres
//                     </h2>
//                     <p className="text-gray-600">
//                         Discover state-of-the-art prototyping facilities near you.
//                     </p>
//                 </div>

//                 <Link
//                     to="/facilities"
//                     className="flex items-center gap-2 border border-gray-200 rounded-full px-5 py-2.5 text-sm font-semibold hover:bg-gray-50"
//                 >
//                     View all centres →
//                 </Link>
//             </div>

//             <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
//                 {centres.map(({ city, rating, machines, experts }) => (
//                     <div key={city} className="rounded-2xl overflow-hidden border border-gray-100 shadow-sm">
//                         <div className="h-32 bg-gradient-to-br from-indigo-600 to-blue-500 relative p-4 flex flex-col justify-between">
//                             <span className="self-end flex items-center gap-1 bg-white/20 backdrop-blur text-white text-xs font-semibold px-2.5 py-1 rounded-full">
//                                 <Star className="w-3 h-3 fill-white" /> {rating}
//                             </span>
//                             <span className="flex items-center gap-1 text-white text-sm font-medium">
//                                 <MapPin className="w-4 h-4" /> {city}
//                             </span>
//                         </div>
//                         <div className="p-5">
//                             <h3 className="font-bold text-gray-900 mb-2">APIC {city}</h3>
//                             <p className="text-sm text-gray-500 mb-4">
//                                 <span className="font-semibold text-gray-700">{machines}</span> machines ·{" "}
//                                 <span className="font-semibold text-gray-700">{experts}</span> experts
//                             </p>
//                             <div className="flex items-center justify-between">
//                                 <span className="flex items-center gap-1.5 text-xs font-medium text-green-600">
//                                     <span className="w-2 h-2 rounded-full bg-green-500" /> Available
//                                 </span>
//                                 <a href="#view" className="text-sm font-semibold text-indigo-600">
//                                     View →
//                                 </a>
//                             </div>
//                         </div>
//                     </div>
//                 ))}
//             </div>
//         </section>
//     );
// }




// ExploreCentres.jsx
import React, { useState, useMemo } from 'react';
import { 
  Star, 
  MapPin, 
  Search, 
  Filter, 
  Cpu, 
  Users, 
  ArrowRight,
  Clock,
  Award,
  Shield,
  Calendar,
  ChevronDown,
  ChevronUp,
  X,
  Sparkles
} from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import './ExploreCentres.css';

const centresData = [
  { 
    id: 1,
    city: "Visakhapatnam", 
    rating: 4.8, 
    machines: 42, 
    experts: 18,
    description: "State-of-the-art prototyping facility with advanced 3D printing and CNC machining capabilities.",
    address: "Plot No. 123, APIIC Industrial Park, Visakhapatnam, AP - 530001",
    phone: "+91 891-234-5678",
    email: "vizag@apicprotohub.in",
    established: "2020",
    facilities: ["3D Printing", "CNC Machining", "PCB Prototyping", "Laser Cutting"],
    images: [
      "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800&h=600&fit=crop&crop=center&auto=format&q=80",
      "https://images.unsplash.com/photo-1581092335871-5f2b5e17cd7a?w=800&h=600&fit=crop&crop=center&auto=format&q=80"
    ],
    availability: "Available",
    hours: "Mon-Sat: 9:00 AM - 6:00 PM"
  },
  { 
    id: 2,
    city: "Vijayawada", 
    rating: 4.7, 
    machines: 36, 
    experts: 14,
    description: "Innovation hub with focus on robotics, automation, and product design prototyping.",
    address: "Survey No. 45, Industrial Area, Vijayawada, AP - 520001",
    phone: "+91 866-345-6789",
    email: "vijayawada@apicprotohub.in",
    established: "2021",
    facilities: ["Robotics", "Automation", "3D Scanning", "Product Design"],
    images: [
      "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800&h=600&fit=crop&crop=center&auto=format&q=80",
      "https://images.unsplash.com/photo-1581092335871-5f2b5e17cd7a?w=800&h=600&fit=crop&crop=center&auto=format&q=80"
    ],
    availability: "Available",
    hours: "Mon-Sat: 9:00 AM - 6:00 PM"
  },
  { 
    id: 3,
    city: "Tirupati", 
    rating: 4.6, 
    machines: 29, 
    experts: 12,
    description: "Advanced manufacturing facility specializing in aerospace components and precision engineering.",
    address: "Plot No. 78, IT Park, Tirupati, AP - 517501",
    phone: "+91 877-456-7890",
    email: "tirupati@apicprotohub.in",
    established: "2021",
    facilities: ["Precision Engineering", "Aerospace", "Quality Testing", "Material Science"],
    images: [
      "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800&h=600&fit=crop&crop=center&auto=format&q=80",
      "https://images.unsplash.com/photo-1581092335871-5f2b5e17cd7a?w=800&h=600&fit=crop&crop=center&auto=format&q=80"
    ],
    availability: "Available",
    hours: "Mon-Sat: 9:00 AM - 6:00 PM"
  },
  { 
    id: 4,
    city: "Kurnool", 
    rating: 4.5, 
    machines: 24, 
    experts: 9,
    description: "Emerging innovation centre with focus on sustainable manufacturing and renewable energy prototyping.",
    address: "Plot No. 234, Industrial Hub, Kurnool, AP - 518001",
    phone: "+91 851-567-8901",
    email: "kurnool@apicprotohub.in",
    established: "2022",
    facilities: ["Sustainable Manufacturing", "Renewable Energy", "IoT", "Smart Sensors"],
    images: [
      "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800&h=600&fit=crop&crop=center&auto=format&q=80",
      "https://images.unsplash.com/photo-1581092335871-5f2b5e17cd7a?w=800&h=600&fit=crop&crop=center&auto=format&q=80"
    ],
    availability: "Available",
    hours: "Mon-Sat: 9:00 AM - 6:00 PM"
  },
  { 
    id: 5,
    city: "Guntur", 
    rating: 4.4, 
    machines: 28, 
    experts: 11,
    description: "Centre of excellence for textile innovation and smart manufacturing solutions.",
    address: "Plot No. 56, Industrial Park, Guntur, AP - 522001",
    phone: "+91 863-678-9012",
    email: "guntur@apicprotohub.in",
    established: "2022",
    facilities: ["Smart Textiles", "Automation", "Process Optimization", "Quality Control"],
    images: [
      "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800&h=600&fit=crop&crop=center&auto=format&q=80",
      "https://images.unsplash.com/photo-1581092335871-5f2b5e17cd7a?w=800&h=600&fit=crop&crop=center&auto=format&q=80"
    ],
    availability: "Available",
    hours: "Mon-Sat: 9:00 AM - 6:00 PM"
  },
  { 
    id: 6,
    city: "Nellore", 
    rating: 4.3, 
    machines: 22, 
    experts: 8,
    description: "Rapid prototyping hub with focus on electronics and PCB development.",
    address: "Plot No. 89, Electronics Park, Nellore, AP - 524001",
    phone: "+91 861-789-0123",
    email: "nellore@apicprotohub.in",
    established: "2023",
    facilities: ["Electronics", "PCB Design", "Hardware Prototyping", "Testing"],
    images: [
      "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800&h=600&fit=crop&crop=center&auto=format&q=80",
      "https://images.unsplash.com/photo-1581092335871-5f2b5e17cd7a?w=800&h=600&fit=crop&crop=center&auto=format&q=80"
    ],
    availability: "Busy",
    hours: "Mon-Sat: 9:00 AM - 6:00 PM"
  }
];

// ========== MAIN COMPONENT ==========
export default function ExploreCentres() {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [showFilters, setShowFilters] = useState(false);
  const [selectedAvailability, setSelectedAvailability] = useState('All');
  const [visibleCount, setVisibleCount] = useState(4);

  const filteredCentres = useMemo(() => {
    let filtered = centresData;
    
    if (searchQuery.trim()) {
      const query = searchQuery.toLowerCase().trim();
      filtered = filtered.filter(centre =>
        centre.city.toLowerCase().includes(query) ||
        centre.description.toLowerCase().includes(query) ||
        centre.facilities.some(f => f.toLowerCase().includes(query))
      );
    }
    
    if (selectedAvailability !== 'All') {
      filtered = filtered.filter(centre => centre.availability === selectedAvailability);
    }
    
    return filtered;
  }, [searchQuery, selectedAvailability]);

  const visibleCentres = filteredCentres.slice(0, visibleCount);
  const hasMore = visibleCount < filteredCentres.length;

  const handleViewMore = () => {
    setVisibleCount(prev => Math.min(prev + 4, filteredCentres.length));
  };

  const handleCentreClick = (id) => {
    navigate(`/centre/${id}`);
  };

  return (
    <section className="explore-centres" id="facilities">
      <div className="explore-container">
        {/* Header */}
        <div className="explore-header">
          <div>
            <div className="explore-badge">
              <Sparkles size={16} />
              <span>Innovation Hubs</span>
            </div>
            <h2 className="explore-title">
              Explore APIC <span>Centres</span>
            </h2>
            <p className="explore-desc">
              Discover state-of-the-art prototyping facilities near you
            </p>
          </div>
          <Link to="/facilities" className="explore-view-all-btn">
            View all centres
            <ArrowRight size={18} />
          </Link>
        </div>

        {/* Search & Filter */}
        <div className="explore-toolbar">
          <div className="explore-search-wrapper">
            <Search size={18} className="explore-search-icon" />
            <input
              type="text"
              placeholder="Search centres by city, facilities, or description..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="explore-search-input"
            />
            {searchQuery && (
              <button className="explore-search-clear" onClick={() => setSearchQuery('')}>
                <X size={16} />
              </button>
            )}
          </div>
          <button className="explore-filter-toggle" onClick={() => setShowFilters(!showFilters)}>
            <Filter size={18} />
            <span>Filters</span>
            {selectedAvailability !== 'All' && (
              <span className="explore-filter-count">1</span>
            )}
            {showFilters ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
          </button>
        </div>

        {/* Filter Options */}
        {showFilters && (
          <div className="explore-filters">
            <div className="explore-filter-header">
              <span className="explore-filter-title">Availability</span>
              {selectedAvailability !== 'All' && (
                <button className="explore-filter-clear" onClick={() => setSelectedAvailability('All')}>
                  <X size={14} /> Clear
                </button>
              )}
            </div>
            <div className="explore-filter-tags">
              {['All', 'Available', 'Busy'].map((option) => (
                <button
                  key={option}
                  className={`explore-filter-tag ${selectedAvailability === option ? 'active' : ''}`}
                  onClick={() => setSelectedAvailability(option)}
                >
                  {option}
                </button>
              ))}
            </div>
          </div>
        )}

        {/* Results Count */}
        

        {/* Centres Grid */}
        <div className="explore-grid">
          {visibleCentres.map((centre) => (
            <div 
              key={centre.id} 
              className="explore-card"
              onClick={() => handleCentreClick(centre.id)}
            >
              <div className="explore-card-image">
                <img
                  src={centre.images[0]}
                  alt={`APIC ${centre.city}`}
                  className="explore-card-img"
                  loading="lazy"
                />
                <div className="explore-card-badge">
                  <Star size={14} className="explore-card-star" />
                  <span>{centre.rating}</span>
                </div>
              </div>
              <div className="explore-card-content">
                <div className="explore-card-header">
                  <h3 className="explore-card-title">APIC {centre.city}</h3>
                  <div className="explore-card-location">
                    <MapPin size={14} />
                    <span>{centre.city}</span>
                  </div>
                </div>
                <p className="explore-card-desc">{centre.description.slice(0, 80)}...</p>
                <div className="explore-card-stats">
                  <div className="explore-card-stat">
                    <Cpu size={14} />
                    <span>{centre.machines} Machines</span>
                  </div>
                  <div className="explore-card-stat">
                    <Users size={14} />
                    <span>{centre.experts} Experts</span>
                  </div>
                </div>
                <div className="explore-card-footer">
                  <div className={`explore-card-availability ${centre.availability === 'Available' ? 'available' : 'busy'}`}>
                    <span className="explore-availability-dot"></span>
                    {centre.availability}
                  </div>
                  <button className="explore-card-btn">
                    View Details
                    <ArrowRight size={16} />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* No Results */}
        {filteredCentres.length === 0 && (
          <div className="explore-no-results">
            <div className="explore-no-results-icon">
              <Search size={32} />
            </div>
            <h4>No centres found</h4>
            <p>Try adjusting your search or filter criteria</p>
            <button onClick={() => { setSearchQuery(''); setSelectedAvailability('All'); }}>
              Clear all filters
            </button>
          </div>
        )}

        {/* View More */}
        {filteredCentres.length > 4 && (
          <div className="explore-view-more">
            <button className="explore-view-more-btn" onClick={handleViewMore} disabled={!hasMore}>
              {hasMore ? (
                <>
                  <span>View More Centres</span>
                  <ArrowRight size={18} />
                </>
              ) : (
                <span>Showing all {filteredCentres.length} centres</span>
              )}
            </button>
          </div>
        )}
      </div>
    </section>
  );
}